import { FeedbackListTable } from '../components/FeedbackListTable';

export function FeedbackListPage() {
  return <FeedbackListTable />;
}
